import { redirectRoutes } from "./redirectRoutes";

export function redirects() {
  window.addEventListener(
    "single-spa:before-routing-event",
    (evt: CustomEvent) => {
      const { newUrl, cancelNavigation } = evt.detail;

      Object.entries(redirectRoutes).forEach(([key, action]) => {
        if (newUrl.includes(key)) {
          action();
          cancelNavigation();
        }
      });
    }
  );
}
